<template>
  <div class="onetofifty_container">
    <!-- 타이머 -->
    <div class="onetofifty_time">
      <div class="onetofifity_timer">
        <Timer
          ref="timer"
          type="stopwatch"
          allow-overflow
          v-slot="{ time, isOverflowed }"
        >
          <span
            :class="{ 'is-overflowed': isOverflowed }"
            style="width: 100%; display:flex; justify-content: center;"
          >
            <div style="width: 20%;">
              <span>{{ time.m }}</span>
            </div>
            <div style="width: 2%;"><span> : </span></div>
            <div style="width: 20%;">
              <span>{{ time.s }}</span>
            </div>
            <div style="width: 2%;"><span> : </span></div>
            <div style="width: 20%;">
              <span>{{ time.ms.substring(0, 2) }}</span>
            </div>
          </span>
        </Timer>
      </div>
      <div class="onetofifity_newgame" v-on:click="() => reGame()">
        <font-awesome-icon icon="redo" style="font-size: 1.5rem;" />
      </div>
    </div>
    <!-- 5 x 5 테이블 -->
    <div class="onetofifty_game">
      <!-- 준비 -->
      <div
        v-show="gameMode === 'ready'"
        v-on:click="() => gamePlay()"
        class="onetofifity_ready"
      >
        <font-awesome-icon
          icon="stopwatch"
          style="font-size: 3rem; margin-bottom: 10px;"
        />
        touch to start
      </div>
      <!-- 종료 -->
      <div v-show="gameMode === 'gameover'" class="onetofifty_share">
        <div class="onetofifty_share_capture" ref="onetofifty_share_capture">
          1 to 50
          <br /><br />
          your record
          <br />
          <div class="onetofifty_share_record">
            {{ recordMin }} : {{ recordSec }} : {{ recordMillisec }}
          </div>
        </div>
        <div style="margin-bottom: 10px; font-size: 0.9rem; color: white;">
          share it with your friends
        </div>
        <share
          url="https://spready.net/onetofifty"
          title="1 to 50"
          :image="image"
        />
      </div>
      <!-- 게임 중 -->
      <div v-show="gameMode === 'play'">
        <table class="onetofifty_matrix">
          <tr v-for="(rowData, rowIndex) in blocks1" :key="rowIndex">
            <td
              class="onetofifty_td"
              v-for="(cellData, cellIndex) in rowData"
              :key="cellIndex"
              @click="onClickTd(rowIndex, cellIndex)"
            >
              {{ cellData }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import shuffle from "lodash.shuffle";
import { TimerVue as Timer } from "@josephuspaye/timer";
import Share from "./Share";

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default {
  name: "OneToFifty",
  components: {
    Timer,
    Share
  },
  data() {
    return {
      currentNum: 1,
      gameMode: "",
      recordMin: 0,
      recordSec: 0,
      recordMillisec: 0,
      image: null,
      blocks1: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
      ],
      blocks2: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
      ],
      clickCnt: [
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0]
      ]
    };
  },
  mounted() {
    this.gameMode = "ready";
    this.generateNumber();
  },
  methods: {
    /* 숫자를 임의의 위치에 생성, cnt 배열 초기화, 매칭 숫자 1로 초기화 */
    generateNumber() {
      let arr1 = [];
      let arr2 = [];

      for (let i = 1; i <= 25; i++) {
        arr1.push(i);
        arr2.push(i + 25);
      }
      arr1 = shuffle(arr1);
      arr2 = shuffle(arr2);

      for (let i = 0; i < 25; i++) {
        let j = parseInt(i / 5);
        let k = i % 5;
        this.blocks1[j][k] = arr1[i];
        this.blocks2[j][k] = arr2[i];
        this.clickCnt[j][k] = 0;
      }
      this.currentNum = 1;
    },
    /* 숫자 클릭 이벤트, 숫자 맞추면 다음 숫자로 바꿔줌 */
    onClickTd(ridx, cidx) {
      if (this.currentNum == this.blocks1[ridx][cidx]) {
        this.currentNum++;
        this.clickCnt[ridx][cidx] += 1;
        let cnt = this.clickCnt[ridx][cidx];
        if (cnt == 1) {
          this.$set(this.blocks1[ridx], cidx, this.blocks2[ridx][cidx]);
        } else {
          this.$set(this.blocks1[ridx], cidx, " ");
        }
      }
    },
    /* 게임 시작하기 */
    gamePlay() {
      this.gameMode = "play";
    },
    /* 게임 다시 시작하기 */
    reGame() {
      this.gameMode = "ready";
      this.currentNum = 1;
    },
    async capture() {
      const onetofiftycoreScreen = this.$refs.onetofifty_share_capture;
      const options = {
        type: "dataURL",
        scale: 2
      };
      const image = await this.$html2canvas(onetofiftycoreScreen, options);
      const file = dataURLtoFile(image, "onetofiftycoreScreen.png");
      this.image = file;
    }
  },
  watch: {
    gameMode: {
      async handler(value) {
        if (value === "gameover") {
          this.recordMin = this.$refs.timer.time.m;
          this.recordSec = this.$refs.timer.time.s;
          this.recordMillisec = this.$refs.timer.time.ms.substring(0, 2);
          this.$refs.timer.toggle();
        } else if (value === "ready") {
          this.$refs.timer.reset();
          this.generateNumber();
        } else if (value === "play") {
          this.$refs.timer.toggle();
        }
      }
    },
    currentNum: {
      async handler(value) {
        if (value >= 51) {
          this.gameMode = "gameover";
          await this.capture();
        }
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@500&display=swap");

.onetofifty_container {
  width: 100%;
  height: 100%;
  font-family: "Rubik", sans-serif;
  display: flex;
  justify-content: top;
  align-items: center;
  text-align: center;
  flex-direction: column;
  color: #776e65;
  background: #faf8ef;
}
.onetofifty_time {
  width: 360px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: row;
}
.onetofifity_timer {
  width: 84%;
  font-size: 2rem;
}
.onetofifity_newgame {
  width: 16%;
  height: 70%;
  background: #cca28d;
  border-radius: 5px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
}
.onetofifty_game {
  width: 360px;
  height: 360px;
  display: flex;
  justify-content: top;
  align-items: center;
  text-align: center;
  flex-direction: column;
  background: #cca28d;
  display: inline-block;
  border-radius: 5px;
  padding: 3px;
}
.onetofifity_ready {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  color: #ffffff;
  font-size: 1rem;
  cursor: pointer;
}
.onetofifty_share {
  width: 100%;
  height: 100%;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
.onetofifty_matrix {
  width: 100%;
  height: 100%;
}
.onetofifty_td {
  width: 66px;
  height: 66px;
  background: #806558;
  border-radius: 5px;
  display: inline-block;
  margin: 1px 2px;
  padding: 9px;
  font-size: 32px;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
  -webkit-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -o-transition: all 0.2s;
  transition: all 0.2s;
  transition-timing-function: ease-in-out;
  -moz-transition-timing-function: ease-in-out;
  -webkit-transition-timing-function: ease-in-out;
  -o-transition-timing-function: ease-in-out;
}
.onetofifty_td:active {
  opacity: 0.3;
}
.onetofifty_share_record {
  font-size: 1.6rem;
  color: #806558;
  text-shadow: 0px 0px 1px black;
}
.onetofifty_share_capture {
  padding: 50px 70px 50px 70px;
  background: #cca28d;
  color: #ffffff;
  display: flex;
  font-size: 1rem;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
}
</style>
